import { DataTableFilter, FilterType } from 'generated/resources/datatable.graphql'
import { FinanceFinancialDocumentFilter } from 'generated/resources/graphql'

import { Filter } from 'modules/core/components/DataTable/types'
import i18n from 'modules/core/lib/i18n'

import { InvoiceFilters } from '../DataTableWrapper/types'

export const statusFilter = (
  onFilterChange: (filters: InvoiceFilters) => void,
  currentTab: string,
  currentStatus?: string[]
): DataTableFilter<FinanceFinancialDocumentFilter> => {
  const onUpdateStatusFilter = (filter?: Filter<string[]>) => {
    const filterValue = Array.isArray(filter?.value) ? filter.value : []
    onFilterChange({ status: filterValue })
  }

  const tabBasedValue = currentTab !== 'all' ? [currentTab] : []
  const statusValue = currentStatus || tabBasedValue

  return {
    identifier: 'status',
    title: i18n.t('finance.invoices.list.fields.payment_status'),
    path: 'status',
    default: statusValue.length > 0,
    type: FilterType.String,
    onUpdateValue: onUpdateStatusFilter,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        value: statusValue,
        options: [
          {
            label: i18n.t('finance.invoices.list.status.processing'),
            value: 'processing',
          },
          {
            label: i18n.t('finance.invoices.list.status.pending'),
            value: 'review',
          },
          {
            label: i18n.t('finance.invoices.list.status.paid'),
            value: 'paid',
          },
          {
            label: i18n.t('finance.invoices.list.status.sent_to_pay'),
            value: 'sent_to_pay',
          },
        ],
      },
    ],
  }
}
